import LoginComponent from '../login-component';
import FormActions from '../../logic/form-actions';
import LoginInput from '../ui-elements/login-input';

import {localize} from '../../infrastructure/localization';

export default class PasswordInput extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get placeholder() {
        return this.isRegister
            ? localize('form-components.password-register')
            : localize('form-components.password-login');
    }

    get error() {
        return this.state.loginModel.validation.errors.password;
    }

    render() {
        return (
            <LoginInput
                componentId={this.state.componentId}
                id="login-password"
                type="password"
                iconId="lock-on"
                value={this.state.loginModel.password}
                label={this.placeholder}
                maxLength={256}
                onBlur={(e) => FormActions.endEditPassword(this.state.componentId)}
                onChange={(e) => FormActions.changePassword(this.state.componentId, e.target.value)}
                error={this.error} />
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/password-input.jsx
 **/